/**
 * The contact-type dot, shared by the Client Detail header badges and the Contacts tab
 * rows so the two can't drift apart.
 *
 * Renders nothing when the type has no color configured, keeping the dot opt-in the same
 * way the header badge is.
 */
export default function ContactTypeDot({ color }) {
  if (!color) {
    return null;
  }

  return (
    <span
      className="h-[10px] w-[10px] flex-none rounded-full"
      style={{ backgroundColor: color }}
      data-testid="contact-type-dot"
    />
  );
}
